























































































































import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import BaseComponent from '../../core/base.component';

@Component({
  name: 'ApprovalCard',
})
export default class ApprovalCard extends BaseComponent {
  @Prop() data!: {
    type: object;
  };

  @Prop() dto?: {
    type: object;
  };

  @Prop() reasonDto?: {
    type: object;
  };
  @Prop() readonly status!: {
    type: string;
  };
  @Prop() readonly histories!: {
    type: string;
  };

  updateApproval() {
    this.$emit('approval');
  }

  updateRefusal() {
    this.$emit('refusal');
  }
}
